import { Col, Row } from "reactstrap";
import React from "react";

export default function TabFinish({
  contractItemObject,
  customersList,
  contractItems_list,
  restructuredDate,
}) {
  return (
    <>
      {" "}
      <div>
        <Row>
          <Col>
            <Row>
              <Col>
                <div>
                  <h4>Customer / Contract</h4>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  <span className={"fw-bold "}>ID: </span>
                  <span className={"fw-light "}>#{contractItemObject?.Id}</span>
                </div>
                <div>
                  <span className={"fw-bold "}>Customer: </span>
                  <span className={"fw-light "}>
                    {
                      customersList?.find(
                        (customer) =>
                          customer.Id === contractItemObject?.Customer_Id
                      )?.FullName
                    }
                  </span>
                </div>
                <div>
                  <span className={"fw-bold "}>Title: </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.Title}
                  </span>
                </div>
                <div>
                  <span className={"fw-bold "}>Printed Title: </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.TitlePrinted}
                  </span>
                </div>
                <div>
                  <span className={"fw-bold "}>Description: </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.Description}
                  </span>
                </div>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col>
                <div>
                  <h4>Contract Options</h4>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <div>
                  <span className={"fw-bold "}>Start Date: </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.StartDateTime &&
                      restructuredDate(contractItemObject?.StartDateTime)}
                  </span>
                </div>
                <div>
                  <span className={"fw-bold "}>End Date: </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.EndDateTime ? (
                      <>{restructuredDate(contractItemObject?.EndDateTime)}</>
                    ) : (
                      <>Ongoing</>
                    )}
                  </span>
                </div>
                <div>
                  <span className={"fw-bold "}>Renewal Date: </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.RenewalDateTime ? (
                      <>
                        {restructuredDate(contractItemObject?.RenewalDateTime)}
                      </>
                    ) : (
                      <>Ongoing</>
                    )}
                  </span>
                </div>
                <div>
                  <span className={"fw-bold "}>
                    Preferred Billing Cycle Day:{" "}
                  </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.PreferredBillingCycleDay?.label}
                  </span>
                </div>
                <div>
                  <span className={"fw-bold "}>Contract Status: </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.ContractStatus_Id?.label}
                  </span>
                </div>
                <div>
                  <span className={"fw-bold "}>Renewal Frequency: </span>
                  <span className={"fw-light "}>
                    {contractItemObject?.UnitFrequency_Id?.label}
                  </span>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
}
